<!-- Promotions / Giveaway tabbed panel -->

<!-- Rounded bar: promotions label + tab pills -->
<div
  class="
    promo-bar
    tw-flex
    tw-items-center
    tw-flex-wrap
    tw-gap-[8px]
    tw-bg-[#EDEDED]
    tw-rounded-[12px]
    tw-p-[10px_14px]
    tw-mb-[16px]
  "
  data-cy="promo-tabs"
>
  <div class="tw-flex tw-items-center tw-mr-[8px]">
    <img
      src="/assets/images/account/promo/promotions_icon.svg"
      alt="promotions"
      class="tw-w-[26px] tw-mr-[10px]"
      data-cy="promo-icon"
    >
    <span class="tw-font-bold tw-text-[17px] tw-text-[#F1685F] tw-tracking-[0.3px]">
      {{ 'ui.account.promotions' | translate: 'Promotions' }}
    </span>
  </div>

  @for (tab of promoTabs; track tab.id) {
    @if (!tab.hidden) {
    <button
      type="button"
      (click)="selectPromoTab(tab.id)"
      class="
        promo-tab
        tw-flex
        tw-items-center
        tw-gap-[8px]
        tw-rounded-[5px]
        tw-px-[16px]
        tw-py-[8px]
        tw-cursor-pointer
        tw-border-0
        tw-transition-colors
      "
      [ngClass]="activePromoTab === tab.id
        ? 'tw-bg-[#FFFFFF] tw-text-[#1A1A1A] tw-shadow-sm'
        : 'tw-bg-[#DADADA] tw-text-[#B9B9B9]'"
      [attr.data-cy]="'promo-tab-' + tab.id"
    >
      <span class="tw-font-bold tw-text-[15px]">{{ tab.label }}</span>
      <span
        class="
          tw-inline-flex
          tw-items-center
          tw-justify-center
          tw-min-w-[20px]
          tw-h-[20px]
          tw-rounded-full
          tw-px-[5px]
          tw-text-[12px]
          tw-font-semibold
          tw-text-[#FFFFFF]
        "
        [ngClass]="activePromoTab === tab.id ? 'tw-bg-[#F1685F]' : 'tw-bg-[#F1B5B0]'"
      >
        {{ promoTabCount(tab.id) }}
      </span>
    </button>
    }
  }
</div>

<!-- Tab content — its own card, separated from the promo bar -->
<div
  class="promo-panel tw-relative tw-bg-[#F9F9F9] tw-rounded-[12px] tw-p-[8px_18px]"
  data-cy="promo-panel"
>
  <!-- Skeleton loader for the initial promo-list fetch (mirrors wager page). -->
  @if (isProcessing && !promoList.length) {
    <div class="promo-skeleton" data-cy="promo-loading-skeleton">
      @for (row of skeletonRows; track row) {
        <div
          class="
            tw-flex tw-items-start tw-justify-between
            tw-py-[12px] tw-border-b tw-border-[#EEF2F7]
          "
        >
          <div class="tw-flex tw-items-start">
            <div class="promo-skeleton__bar tw-w-[18px] tw-h-[18px] tw-rounded-[4px] tw-mt-[3px] tw-mr-[10px]"></div>
            <div>
              <div class="promo-skeleton__bar tw-h-[14px] tw-w-[190px] tw-rounded-[4px] tw-mb-[8px]"></div>
              <div class="promo-skeleton__bar tw-h-[12px] tw-w-[230px] tw-rounded-[4px] tw-mb-[8px]"></div>
              <div class="promo-skeleton__bar tw-h-[11px] tw-w-[120px] tw-rounded-[4px]"></div>
            </div>
          </div>
          <div class="promo-skeleton__bar tw-h-[32px] tw-w-[80px] tw-rounded-[16px]"></div>
        </div>
      }
    </div>
  }

  @switch (activePromoTab) {
    @case ('giveaway') {
      @if (!isProcessing && !promoList.length) {
        <div class="tw-p-[14px] tw-text-[13px] tw-text-[#6B7280]" data-cy="promo-empty">
          {{ 'ui.account.no.active.promotions.right.now' | translate: 'No active promotions right now.' }}
        </div>
      }

      <div class="promo-list">
        @for (promo of promoList; track trackByName($index, promo)) {
          <div
            class="
              promo-item
              tw-flex
              tw-items-start
              tw-justify-between
              tw-py-[12px]
              tw-border-b
              tw-border-[#EEF2F7]
            "
            [attr.data-cy]="'promo-item'"
          >
            <div class="tw-flex tw-items-start">
              <!-- Type icon: gift for giveaways, promo otherwise -->
              @if (promo.type === 'Giveaway') {
                <img
                  src="/assets/images/account/promo/gift_icon.png"
                  alt="gift-icon"
                  class="tw-mt-[3px] tw-mr-[10px] tw-w-[18px] tw-h-[18px]"
                >
              } @else if (promo.type === 'Promo') {
                <img
                  src="/assets/images/account/promo/promo_icon.png"
                  alt="promo-icon"
                  class="tw-mt-[3px] tw-mr-[10px] tw-w-[18px] tw-h-[18px]"
                >
              }
              <div>
                <p class="tw-font-bold tw-text-[14px] tw-text-[#3B3B3B]" data-cy="promo-name">
                  {{ (promo.publicname || '') | stripHtml }}
                </p>
                <p class="tw-text-[12px] tw-text-[#6B7280] tw-mt-[2px]" data-cy="promo-desc">
                  {{ (promo.description || '') | stripHtml }}
                </p>
                <p class="tw-text-[11px] tw-text-[#9AA3AF] tw-mt-[4px]">
                  {{ promo.startdate | dateFormat: 'MM/DD/YYYY' }}
                  &ndash;
                  {{ promo.enddate | dateFormat: 'MM/DD/YYYY' }}
                </p>
              </div>
            </div>

            @if (promo.isLoading) {
              <!-- Claim in flight -->
              <button
                mat-stroked-button
                disabled
                class="promo-use-btn !tw-text-[12px] !tw-min-w-[80px]"
                data-cy="promo-use-btn"
              >
                <mat-progress-spinner
                  mode="indeterminate"
                  [diameter]="16"
                ></mat-progress-spinner>
              </button>
            } @else if ((promo | optInStatus) === 'showButton') {
              <!-- Claimable -->
              <button
                mat-stroked-button
                (click)="usePromo(promo)"
                class="promo-use-btn !tw-text-[12px] !tw-min-w-[80px]"
                data-cy="promo-use-btn"
              >
                {{ 'promos.optin.usenow' | translate: 'Use Now' }}
              </button>
            } @else {
              <!-- Disabled state (Upcoming / Used / No Opt-in) -->
              <button
                mat-stroked-button
                disabled
                class="promo-use-btn !tw-text-[12px] !tw-min-w-[80px]"
                data-cy="promo-use-btn"
              >
                {{ (promo | optInStatus) | titlecase }}
              </button>
            }
          </div>
        }
      </div>
    }

    @case ('free-spin') {
      <div class="tw-p-[14px] tw-text-[13px] tw-text-[#6B7280]">
        {{ 'ui.account.no.active.free.spin.promotions.right' | translate: 'No active free-spin promotions right now.' }}
      </div>
    }

    @case ('refer-a-friend') {
      <div class="tw-p-[14px] tw-text-[13px] tw-text-[#6B7280]">
        {{ 'ui.account.invite.a.friend.to.amwager.and' | translate: 'Invite a friend to AmWager and earn bonuses when they place their first bet.' }}
      </div>
    }
  }
</div>
